import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid2,
  Button,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router";
import PackageListings from "../../utils/services/PackageListing.api";
import { getStorageValue, setStorageValue } from "../../utils/helper";
import { ReactComponent as Edit} from "../../assets/logos/editIconWhite.svg";
import { ReactComponent as AvatarImage} from "../../assets/logos/profileAvatar.svg";
import Loaders from "../common/Loaders";
import UserProfile from "./UserProfile";

const AdminPage = () => {
  const navigate = useNavigate();
  const [profileInfo, setProfileInfo] = useState([]);
  const [loader, setLoader] = useState(false);

  const getProfileDetails = async () => {
    setLoader(true);
    const userId = getStorageValue("userId");
    try {
      const res = await PackageListings.getUserProfile(userId);
      setStorageValue("userInfo", JSON?.stringify(res?.data));
      setProfileInfo(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getProfileDetails();
  }, []);

  const formatPhoneNumber = (value) => {
    const cleaned = value?.replace(/\D/g, "");

    const match = cleaned?.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }

    return cleaned;
  };

  return profileInfo?.roleId === 2 ? (
    <UserProfile userData={profileInfo} />
  ) : (
    <Box
      sx={{
        minHeight: "100vh",
      }}
    >
      <Typography sx={{ fontWeight: "500", fontSize: "24px" }}>
        {Number(getStorageValue("roleId")) === 1 ? "Admin" : "Profile"}
      </Typography>
      <Card
        sx={{
          width: "100%",
          border: "1px solid #E6EDFF",
          borderRadius: 2,
          paddingLeft: "5px",
          marginTop: "1rem",
        }}
      >
        <CardContent>
        {profileInfo?.roleId === 1 && (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: 0.5,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  marginBottom: 2,
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                }}
              >
                <AvatarImage />
                <span>Profile Information</span>
              </Typography>
              <Button
                onClick={() => navigate("/editProfile")}
                variant="contained"
                color="primary"
                sx={{
                  gap: "7px",
                  height: "40px",
                  textTransform: "capitalize",
                  background: "#0C68F4",
                  borderRadius: "8px",
                }}
              >
                <Edit />
                Edit
              </Button>
            </Box>
            <Divider sx={{ my: 1 }} />
            </>
          )}
          {loader && <Loaders />}
          <Grid2 container spacing={2} sx={{ marginTop: "20px" }}>
            <Grid2
              item
              xs={6}
              spacing={2}
              sx={{
                paddingTop: "12px",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                width: "50%",
              }}
            >
              <Typography variant="body2" sx={{ color: "#475467" }}>
                Name
              </Typography>
              <Typography sx={{ fontWeight: "600" }} variant="body2">
                {profileInfo?.firstName} {profileInfo?.lastName}
              </Typography>
            </Grid2>
            <Grid2
              item
              xs={6}
              sx={{
                paddingTop: "12px",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <Typography variant="body2" sx={{ color: "#475467" }}>
                Phone Number
              </Typography>
              <Typography sx={{ fontWeight: "600" }} variant="body2">
                {" "}
                {profileInfo?.phoneNumber
                  ? `${profileInfo?.countryCode || ""} (${formatPhoneNumber(
                      profileInfo?.phoneNumber
                    )})`
                  : ""}
              </Typography>
            </Grid2>
          </Grid2>
          <Grid2 container spacing={2} sx={{ marginTop: "20px" }}>
            <Grid2
              item
              xs={6}
              sx={{
                paddingTop: "12px",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                width: "50%",
              }}
            >
              <Typography variant="body2" sx={{ color: "#475467" }}>
                Email 1
              </Typography>
              <Typography sx={{ fontWeight: "600" }} variant="body2">
                {profileInfo?.email}
              </Typography>
            </Grid2>
            <Grid2
              item
              xs={6}
              sx={{
                paddingTop: "12px",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <Typography variant="body2" sx={{ color: "#475467" }}>
                Email 2
              </Typography>
              <Typography sx={{ fontWeight: "600" }} variant="body2">
                {profileInfo?.email2 || "-"}
              </Typography>
            </Grid2>
          </Grid2>
          <Grid2 container spacing={2} sx={{ marginTop: "20px" }}>
            <Grid2
              item
              xs={6}
              sx={{
                paddingTop: "12px",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                width: "50%",
              }}
            >
              <Typography variant="body2" sx={{ color: "#475467" }}>
                Address
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "600",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  overflowWrap: "break-word",
                }}
              >
                {profileInfo?.address?.street || ""}{" "}
                {` ${profileInfo?.address?.city || ""}`}
                <br />
                {profileInfo?.address?.state || ""}
                {` ${profileInfo?.address?.zipCode || ""}`}
              </Typography>
            </Grid2>
            <Grid2
              item
              xs={6}
              sx={{
                paddingTop: "12px",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <Typography variant="body2" sx={{ color: "#475467" }}>
                State
              </Typography>
              <Typography sx={{ fontWeight: "600" }} variant="body2">
                {profileInfo?.address?.state}{" "}
              </Typography>
            </Grid2>
          </Grid2>
          <Grid2 container spacing={2} sx={{ marginTop: "20px" }}>
            <Grid2
              item
              xs={6}
              sx={{
                paddingTop: "12px",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                width: "50%",
              }}
            >
              <Typography variant="body2" sx={{ color: "#475467" }}>
                City
              </Typography>
              <Typography sx={{ fontWeight: "600" }} variant="body2">
                {profileInfo?.address?.city}{" "}
              </Typography>
            </Grid2>
            <Grid2
              item
              xs={6}
              sx={{
                paddingTop: "12px",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <Typography variant="body2" sx={{ color: "#475467" }}>
                Zipcode
              </Typography>
              <Typography sx={{ fontWeight: "600" }} variant="body2">
                {profileInfo?.address?.zipCode}{" "}
              </Typography>
            </Grid2>
          </Grid2>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AdminPage;
